<template>
  <section> 
    <b-row>    
      <b-col>
        <b-card
          style="max-width: 100%">
            <template v-slot:header >
              <div class="header-card text-left">
                Lista de garantias
                <b-button size="sm" @click="getDataGet({route: 'agenda_lista', data: 'agenda del dia'})" variant="outline-primary" style="float:right"> <b-icon scale="1.5" icon="arrow-repeat"></b-icon> Sincronizar</b-button>            
              </div>
            </template>
            <b-row>
              <b-col :md="12" style="margin-top:10px">
                  <sw-tableget
                    :tableItems="tableGBItems"
                    :tableSearch="tableGBSearch"
                    :tableOptions="tableGBoptions"
                    name="tableAgenda"
                    route="lista_garantias"
                    dataRoute="agenda del dia"                    
                    >
                    <template v-slot:modal>
                      <sw-modalgarantiaexamen 
                        v-if="openModal.modal.modal==='examen'"
                        @save="saveForm"
                        >
                      </sw-modalgarantiaexamen>
                      
                      <sw-modalgarantiadelete
                        v-if="openModal.modal.modal==='Eliminar'"
                        @save="saveForm"
                        >
                      </sw-modalgarantiadelete>  
                    </template>
                  </sw-tableget>                  
              </b-col>              
            </b-row>            
        </b-card>
      </b-col>
    </b-row>                    
  </section>
</template>
<script>
import indexMix  from './indexMix.js'
import storeMix  from './storeMix.js'
import tableMix  from './tableMix.js'
import saveMix  from './saveMix.js'
import saveMixins  from '@/mixings/save.js'
import SwInputs from '@/components/forms/inputs.vue'
import SwSaveform from '@/components/forms/saveForm.vue'
import SwTableget from '@/components/dataTable/tableGet.vue'
import SwModalgarantiadelete from '@/components/modals/garantiadelete.vue'
import SwModalgarantiaexamen from '@/components/modals/garantiaexamen.vue'


export default { 
  name: "inventario_listproductos",
  mixins: [indexMix,storeMix,tableMix,saveMix,saveMixins,],
  components: {
  SwInputs,
  SwSaveform,
  SwTableget,
  SwModalgarantiadelete ,
  SwModalgarantiaexamen     
  }
}
</script>
<style>
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link
{
  background: #fcfcfc;
  font-weight: 500;
}
</style>
